import { defineComponent as _defineComponent } from 'vue'
import { computed } from "vue";
import { NolaPfMicroCmsContest } from "@/lib/models/nolaPfContest";
import { optimizeImage } from "@/lib/utils/url";


export default /*#__PURE__*/_defineComponent({
  __name: 'ContestEntryFormContestAside',
  props: {
    contest: { type: null, required: true }
  },
  setup(__props: any) {

const props = __props as {
  contest: NolaPfMicroCmsContest | null;
};



const contestImageUrl = computed(() => {
  const url = props.contest?.image.url;
  if (!url) return "";
  return optimizeImage(url);
});

return { __sfc: true,props, contestImageUrl }
}

})